<template>
  <el-select v-bind="$attrs" v-on="$listeners" :placeholder="$t(placeholder)">
    <el-option v-for="(item, index) in dictList" :key="index" :label="$t(item.name)" :value="item.dictValue" />
  </el-select>
</template>

<script>
export default {
  name: "DictSelect",
  props: {
    flag: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "请选择"
    }
  },
  data() {
    return {

    }
  },
  computed: {
    dictList() {
      return this.$store.getters.getDictByFlag(this.flag);
    }
  }
}
</script>

<style scoped>

</style>
